import { ICellRendererParams } from "ag-grid-community";

import type { RequestRow } from "../requestLogGridTypes";

import { HydrationPendingCell, isRequestRowHydrating } from "./HydrationPendingCell";
import { renderHighlightedPreview } from "./renderHighlightedPreview";
import { ScrollablePreviewCell } from "./ScrollablePreviewCell";

import { getRequestLogInputPreviewText } from "@/utils/requestLogPreviewDisplay";

export const InputTextCellRenderer = ({ data }: ICellRendererParams<RequestRow>) => {
  const preview = getRequestLogInputPreviewText({
    input_text: data?.input_text,
    prompt_preview: data?.prompt_preview,
  });

  if (isRequestRowHydrating(data) && !preview) {
    return <HydrationPendingCell />;
  }

  if (!preview) {
    return <span className="text-gray-400">-</span>;
  }

  return (
    <ScrollablePreviewCell>
      {/<em>/i.test(preview) ? renderHighlightedPreview(preview) : preview}
    </ScrollablePreviewCell>
  );
};
